import React, { memo, useEffect } from 'react';
import { useFlag } from '@unleash/proxy-client-react';

export type WithFeatureFlagProps = {
    featureFlag: string;
    children: React.ReactNode;
    __enableDebug?: boolean; // for testing purposes only
};

const WithFeatureFlagComponent: React.FC<WithFeatureFlagProps> = (props) => {
    const enabled = useFlag(props.featureFlag);

    useEffect(() => {
        props.__enableDebug && console.warn(`Feature flag ${props.featureFlag} is ${enabled} in debug mode!!`);
    }, [enabled, props.__enableDebug, props.featureFlag]);

    if (props.__enableDebug || enabled) {
        return <React.Fragment>{props.children}</React.Fragment>;
    }

    return null;
};

export const WithFeatureFlag = memo(WithFeatureFlagComponent);
